// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__36zq5","title":"AfterBackImages_title__3P-zZ","images":"AfterBackImages_images__2LcSz"};